var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Duplicar",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64844 13.2984H12.3484V11.3984H6.64844V13.2984ZM6.64844 16.15H12.3484V14.25H6.64844V16.15ZM13.305 17.0992L13.3041 10.4492H8.55313V5.69922H5.70312V17.0992H13.305ZM15.1969 7.20748V17.1008C15.1969 18.1486 14.3447 19.0008 13.2969 19.0008H5.69688C4.64902 19.0008 3.79688 18.1486 3.79688 17.1008V5.70078C3.79688 4.65293 4.64902 3.80078 5.69688 3.80078H11.7902L15.1969 7.20748ZM7.6 1.9H1.9V13.3H0V1.9C0 0.85215 0.85215 0 1.9 0H7.6V1.9Z",
    fill: "#A8A8A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.f63147f6a4cac715c99c4b9f357bd9ea.svg";
export { ForwardRef as ReactComponent };